// 通用下载方法
import axios from 'axios'
import { saveAs } from 'file-saver'
import { parseTime } from '@/utils'
import netConfig from "../../config/net.config";
let downloadLoadingInstance;
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    // baseURL: 'https://admin.ciaojian.com/',
	// baseURL: 'http://localhost:8089',
	baseURL: netConfig.baseUrl,
    // 超时
    timeout: 10000
})
// service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 下载文件
export function downloadFile(obj, name, suffix) {
	const url = window.URL.createObjectURL(new Blob([obj]))
	const link = document.createElement('a')
	link.style.display = 'none'
	link.href = url
	const fileName = parseTime(new Date()) + '-' + name + '.' + suffix
	link.setAttribute('download', fileName)
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
}

export function download(url, params, filename, config) {
    // downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
    return service.post(url, params, {
        transformRequest: [(params) => { return params }],
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType: 'blob',
        ...config
    }).then(async (data) => {
        const blob = new Blob([data])
        saveAs(blob, filename)
        downloadLoadingInstance.close();
    }).catch((r) => {
        console.error(r)
        Message.error('下载文件出现错误，请联系管理员！')
        downloadLoadingInstance.close();
    })
}

export default service
